export default __webpack_public_path__ + "static/media/slider11.24c0ddc3.jpg";